// extracted by mini-css-extract-plugin
export default {"social":"SocialLinks_social__EyIQe"};